import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetSubscribeInfo = (designerId: string, t?: any) => {

    const [resp, setResp] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!designerId) return;

        setIsLoading(true)
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/Designer/Statistics')
            .get()
            .addQuery('designerId', designerId)
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoading(false)
                setResp(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [designerId, t])

    return {info: resp, isLoading, error};
}import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetSubscribeInfo = (designerId: string, t?: any) => {

    const [resp, setResp] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!designerId) return;

        setIsLoading(true)
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/Designer/Statistics')
            .get()
            .addQuery('designerId', designerId)
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoading(false)
                setResp(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [designerId, t])

    return {info: resp, isLoading, error};
}